<template>
  <div class="authorCenter" :style="ispopshow?'height:100vh;overflow:hidden':''">
    <Header></Header>
    <div class="authorBox flexible authorBox-big">
      <sidebar :noticeNum="noticeNum"></sidebar>
      <div class="writewrap flex mb30">
        <Bread>
          <div slot="new-stroy">
            <el-button icon="el-icon-edit" class="f16 writebook font-MT" @click="goBookSet(0, false)">{{$lang('authorCenter.stories.newStory')}}</el-button>
          </div>
        </Bread>
        <writeList
                @changePop="changePop"
                :booklist="booklist"
          ></writeList>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthorBookList } from 'apiurl/author';
import {noticecount} from 'apiurl/notice';
export default {
  data() {
    return {
      booklist: [],
      uploadurl: "",
      /*分页*/
      totalPage: 0,
      busy: false,
      pageNo: 1,
      /*未读消息*/
      noticeNum: 0,
      ispopshow: false,
    };
  },
  created() {
    this.getwriteList(1);
  },
  mounted() {
    window.addEventListener('scroll', this.getbottom); // 滚动到底部，再加载的处理事件
    this.getnoticecount()
  },
  methods: {
    // 获取作者写书列表
    async getwriteList() {
      let res = await AuthorBookList({ pageSize: 10, pageNo: this.pageNo });
      if (res.success) {
        if (res.data.items) {
          this.booklist = this.booklist.concat(res.data.items);
        };
        this.totalPage = Number(res.data.totalPage);
        this.busy = res.data.hasNextPage
        this.pageNo = Number(res.data.pageNum)
      }
    },
    // 获取未读消息总数
    async getnoticecount () {
      let res = await noticecount({sort: 1});
      if (res.success) {
        this.noticeNum = res.data
      }
    },
    goBookSet() {
      this.$router.push('/Create/0');
    },
    getbottom() {
      let scrollTop =
              document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight =
              document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight =
              document.documentElement.scrollHeight || document.body.scrollHeight;
      let numHeight = scrollTop + clientHeight;
      if (scrollHeight > clientHeight && numHeight > scrollHeight - 100) {
        if (this.busy) {
          this.busy = false;
          this.pageNo++;
          this.getwriteList()
        }
      }
    },
    changePop (data) {
      this.ispopshow = data
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";

</style>
